import React, { Fragment, useEffect, useRef, useState } from 'react';

import Banner from './components/Banner/Banner';
import Features from './components/Features/Features';
import Stepper from './components/stepper/Stepper';
import { Notification } from 'featureLib/NotificationComponent';

import { DEFAULT_NOTIFICATION, UnauthSteps } from 'home/view/check-feasibility/unauth-view/constant';
import { LEAD_ID } from 'home/view/manage-feasibility/constants';
import { setInSessionStorage, getFromSessionStorage, scrollToRef, setMetaTags } from 'common/utils/app.utils';
import { AUTHORIZATION_HEADER, MODULE_ID, UNAUTH_ACTIVE_STEP } from 'home/common/constants/constants';
import { CUSTOMER_DETAILS_FORM_CONFIG } from './components/CustomerDetails/formConfig';

import CustomerDetails from './components/CustomerDetails';
import LocationDetails from './components/LocationDetails/LocationDetails';
import ThanksPage from 'featureLib/ThankYou';
import OrderSummary from './components/OrderSummary';
import MainLoader from 'common/components/loader/loader.component';

import useStateWithCb from 'home/components/customHook/useStateWithCb';

import './index.scss';
import { META_TAGS } from 'common/constants/app.constants';

const CheckFeasibilityUA = (props) => {
  const customerDetailsRef = useRef(null);
  const { isUnAuthJourney } = props;
  const customerLastActiveStep = getFromSessionStorage(MODULE_ID, UNAUTH_ACTIVE_STEP);

  const [loader, showLoader] = useState(false);
  const [activeStepIndex, setActiveStepIndex] = useState(customerLastActiveStep ?? 0);
  const [notification, setNotification] = useState(DEFAULT_NOTIFICATION);
  const [customerDetailsFormState, setCustomerDetailsFormState] = useState(() => CUSTOMER_DETAILS_FORM_CONFIG);
  const [leadId, setLeadId] = useStateWithCb(getFromSessionStorage(MODULE_ID, LEAD_ID) ?? null);
  const [editButtonClick, setEditButtonClick] = useState(null);
  const [userFilledPincode, setUserFilledPincode] = useState(null);

  const renderNotifications = () => {
    return (
      <section id="notification" className="notification">
        <Notification
          show={notification.show}
          message={notification.message}
          type={notification.type}
          eventHandler={notification.eventHandler ?? toggelNotification}
          onCancel={notification.onCancel ?? toggelNotification}
        ></Notification>
      </section>
    );
  };

  const toggelNotification = () => {
    setNotification(DEFAULT_NOTIFICATION);
  };

  const showNotification = (show, message, type, eventHandler, onCancel) => {
    setNotification({ show, message, type, eventHandler, onCancel });
  };

  const updateActiveIndex = (stepId) => {
    setActiveStepIndex(stepId);
    setInSessionStorage(MODULE_ID, UNAUTH_ACTIVE_STEP, stepId);
  };

  const renderLoader = () => {
    return (
      <div className="loader-container">
        <MainLoader />
      </div>
    );
  };

  const renderChildren = () => {
    const combinedProps = {
      ...props,
      showNotification,
      updateActiveIndex,
      showLoader,
      customerDetailsFormState,
      setCustomerDetailsFormState,
      editButtonClick,
      setEditButtonClick,
      setLeadId,
      userFilledPincode,
      setUserFilledPincode,
      toggelNotification
    };

    switch (activeStepIndex) {
      case 1: {
        return <CustomerDetails {...combinedProps} />;
      }
      case 2: {
        return <LocationDetails {...combinedProps} />;
      }
      case 3: {
        return <OrderSummary {...combinedProps} />;
      }
      case 4: {
        return <ThanksPage isAuthJourney={!isUnAuthJourney} leadId={leadId} />;
      }
      default: {
        return <CustomerDetails {...combinedProps} />;
      }
    }
  };

  /** handle manual url change scenario. If lead is created, skip CustomerDetails step */

  useEffect(() => {
    const doesLeadExist = getFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER);
    toggelNotification();
    scrollToRef(customerDetailsRef);
    setMetaTags(META_TAGS.B2B_CHECK_FEASIBILITY);
    if (doesLeadExist) {
      updateActiveIndex(2);
    }
  }, []);

  return activeStepIndex > UnauthSteps.length ? (
    <Fragment>
      {renderNotifications()}
      {loader ? renderLoader() : renderChildren()}
    </Fragment>
  ) : (
    <Fragment>
      <Banner showBtn={false} defaultConfig />
      <div className="customer_details_container" ref={customerDetailsRef}>
        <div className="container">
          <div className="customer_details_section">
            <h2 className="heading">Check for service availability</h2>
            <h4 className="sub_heading">Enter your details to proceed</h4>
            <div className="stepper">
              <Stepper steps={UnauthSteps} activeStepIndex={activeStepIndex} />
            </div>
            {renderNotifications()}
            {loader ? renderLoader() : renderChildren()}
          </div>
        </div>
      </div>
      <Features />
    </Fragment>
  );
};

export default CheckFeasibilityUA;
